import apiUrl from '../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import Manual from './Manual/index.vue';
import WeighingScale from './WeighingScale/index.vue';
import DWSInscan from './DWSInscan/index.vue';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import VueElementLoading from 'vue-element-loading';
import PendingInscanShipmentList from './PendingInscanShipmentList/index.vue';
import ReloadInscanShipmentList from './ReloadInscanShipmentList/index.vue';

export default {
  name: 'hub-inscan',
  components: {
		DatePicker,
		'first': Manual,
		'second': WeighingScale,
		'third': DWSInscan,
		Paginate,
		VueElementLoading,
		'Fourth':PendingInscanShipmentList,
		'Fifth':ReloadInscanShipmentList
	},
	props: [],
	data() {
		return {
			currentTab: 'First',
			componentKey: 0,
			tabs: [{
					key: 'First',
					value: 'Manual'
				},
				{
					key: 'Second',
					value: 'Weighing Scale'
				},
        {
          key: 'Third',
          value: 'DWS Inscan'
        },
			],
			pageNo: 1,
			limit: 10,
			totalRows: 0,
			hubid:0,
			PendingShipmentArray:[],
			pageCount: 0,
			showTable:false,
			isLoading:false,
			tabsForShipments: [{
					key: 'Fourth',
					value: 'Pending Inscan Shipment List'
				},
				{
					key: 'Fifth',
					value: 'Reload Inscan Shipment List'
				}
			],
			currentTabForShipment:'Fourth',
			componentKeyForShipment: 0,

		}
	},
	computed: {
		// selects all checkbox's option
		currentTabComponent: function() {
			this.componentKey += 1
			return this.currentTab.toLowerCase()
		},
		currentTabComponentForShipment: function() {
			this.componentKeyForShipment += 1
			return this.currentTabForShipment.toLowerCase()
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.hubid = userdetail[0].HubId;
	},
	methods: {}
}



// WEBPACK FOOTER //
// ./src/views/components/HubInscan/HubInscan.js